import * as React from 'react';
import { injectIntl } from 'react-intl';
import { Grid, Loader } from 'semantic-ui-react';

import { Card } from '../..';
import { localeData } from '../../../locales/data';
import { AchievementsList } from '../../AchievementsList';

import { AchievementsMainPropsGeneric } from './types';
import analytics from '../../../shared/services/analytics/analytics';

const AchievementsMain = ({ isFetching, data, intl }: AchievementsMainPropsGeneric) => {
  const handleViewAchievementClick = () => {
    analytics.trackCustomEvent('dashboard_click_achievement_detail');
  };

  return (
    <Grid.Column tablet={8} mobile={16} computer={5}>
      <Card
        title={intl.formatMessage({
          id: 'dashboardMain.dashboardBottomRow.achievements',
          defaultMessage: localeData.en['dashboardMain.dashboardBottomRow.achievements'],
        })}
        headerLink="/profile/achievements"
        headerLinkLabel={intl.formatMessage({
          id: 'dashboardMain.dashboardBottomRow.viewAchievements',
          defaultMessage: localeData.en['dashboardMain.dashboardBottomRow.viewAchievements'],
        })}
        onHeaderLinkClick={handleViewAchievementClick}
      >
        {isFetching ? (
          <div className="'dashboard__loader">
            <Loader active={true} inline="centered" size="massive" />
          </div>
        ) : (
          <AchievementsList data={data} />
        )}
      </Card>
    </Grid.Column>
  );
};

export default injectIntl(AchievementsMain);
